import * as Sentry from '@sentry/react';

const isRecordLike = (parsed: unknown): boolean =>
  typeof parsed === 'object' &&
  parsed !== null &&
  !Array.isArray(parsed) &&
  typeof (parsed as { id?: unknown }).id === 'string';

// one corrupt record must not cost us the rest of the batch it arrived in, and valid JSON
// that is not a record would reach the tldraw store and throw there instead
export const parseRecordSafely = (serialized: string): unknown | null => {
  let parsed: unknown;

  try {
    parsed = JSON.parse(serialized);
  } catch (error) {
    Sentry.captureException(error);

    return null;
  }

  if (!isRecordLike(parsed)) {
    Sentry.captureException(new Error('Whiteboard record is not a record'));

    return null;
  }

  return parsed;
};
